import { DocumentInterface, DocumentV2 } from 'features/Documents'
import { Factory } from 'fishery'

export const documentV2Factory = Factory.define<DocumentV2>(() => ({
  id: '6413a62399c754001cbe4451',
  createdAt: '2023-04-19T21:21:45.352Z' as unknown as DocumentV2['createdAt'],
  updatedAt: '2023-04-19T21:21:45.358Z' as unknown as DocumentV2['updatedAt'],
  updatedBy: {
    id: 'test@example.com',
    email: 'test@example.com',
    fullName: 'test@example.com',
  },
  createdBy: {
    id: 'test@example.com',
    email: 'test@example.com',
    fullName: 'test@example.com',
  },
  bucket: 'freighthub.documents.sandbox',
  source: 'operations',
  entityID: 'S12345',
  entityType: 'shipment',
  customerID: 'C-12345',
  fileName: 'test.pdf',
  mimeType: 'application/pdf',
  s3FileName: 'testfile.pdf',
  state: 'published',
  legacyID: '6413a62399c754001cbe4451',
  documentTypeCode: 'other',
  correlation: null,
  version: 1,
  publishedVersion: 1,
}))

export const shipmentDocumentFactory = Factory.define<DocumentInterface>(() => ({
  _id: '6463805e23cecc001c05710a',
  customer_id: 'C-12345',
  createdAt: '2023-05-16T13:08:46.364Z' as unknown as DocumentInterface['createdAt'],
  file: 'testfile.pdf',
  name: 'test.pdf',
  mimeType: 'application/pdf',
  role: 'bookingNote',
  internal: false,
  userProvided: false,
  modifiedAt: '2023-05-16T13:08:46.364Z' as unknown as DocumentInterface['modifiedAt'],
  createdBy: 'test@example.com',
  author_user: {
    email: 'test@example.com',
    firstName: '',
    lastName: 'Forto Team',
  },
}))
